import React from "react";

import LocationCard from "@/src/components/cards/location-card/location-card";
import PractitionerCard from "@/src/components/cards/practitioner-card/practitioner-card";
import {
  useReferralLocationSwitchHandler,
  useReferralPractitionerSwitchHandler,
} from "@/src/hooks/use-entity-switch-handlers";
import { Referral } from "@/src/models/documents/referral";

interface ReferralProviderCardsProps {
  referral: Referral;
}

export function ReferralProviderCards({ referral }: ReferralProviderCardsProps) {
  const { createLocationSwitchHandler, isPending: isLocationPending } = useReferralLocationSwitchHandler();
  const { createPractitionerSwitchHandler, isPending: isPractitionerPending } = useReferralPractitionerSwitchHandler();

  const providerSections = [
    {
      type: "Primary Care" as const,
      provider: referral.primaryCareProvider,
      location: referral.primaryCareLocation,
      providerKey: "primaryCareProvider" as const,
      locationKey: "primaryCareLocation" as const,
    },
    {
      type: "Referring" as const,
      provider: referral.referringProvider,
      location: referral.referringLocation,
      providerKey: "referringProvider" as const,
      locationKey: "referringLocation" as const,
    },
    {
      type: "Receiving" as const,
      provider: referral.receivingProvider,
      location: referral.receivingLocation,
      providerKey: "receivingProvider" as const,
      locationKey: "receivingLocation" as const,
    },
  ];

  return (
    <>
      {providerSections.map(({ type, provider, location, providerKey, locationKey }) => (
        <React.Fragment key={type}>
          {provider && (
            <PractitionerCard
              practitioner={provider}
              type={type}
              isEditable
              onEditPractitioner={createPractitionerSwitchHandler(referral, providerKey)}
              onEditPractitionerLoading={isPractitionerPending}
            />
          )}
          {location && (
            <LocationCard
              location={location}
              type={type}
              isEditable
              onEditLocation={createLocationSwitchHandler(referral, locationKey)}
              onEditLocationLoading={isLocationPending}
            />
          )}
        </React.Fragment>
      ))}
    </>
  );
}
